module.exports = __webpack_public_path__ + "fonts/1b950d2a-907a-4888-8056-0d44e8e86338.9325c67.eot";